module.exports = __webpack_public_path__ + "static/media/share-btn.7b534e2c.png";